import { LotSizings } from '@/features/lot-sizings/lot-sizings';
import { AppLayout } from '@/layouts/app-layout';

export function LotSizingsPage() {
  return (
    <AppLayout>
      <LotSizings />
    </AppLayout>
  );
}
